import Filter from './filter';
import { computeCurrencyMaxCharCount, computeNumberMaxCharCount, computePercentageMaxCharCount, processChildrenToMap, computeCumulativeMap } from "@/utils/transformers";
import { computeMinMax } from "@/utils";
import { request } from "@/store";
import moment from "moment";
import { FLOATING_COMPOUND_TABLE_STATES, GROUP_BY_TAB_ELEMENTS, APP_PERIOD_DROPDOWN_ELEMENTS, TARGETING_TYPE_SPLIT } from "@/utils/constants";
import { DATE_PICKER_RANGE_TITLES, getHistoryPeriodSelector } from '../utils/datepicker';
import { PERIOD_OPTIONS, PERIOD_OPTIONS_V2 } from '../utils/constants';
import { Currencies } from '../utils/currencies';
const DEFAULT_EMPTY_ROW_SIZE = 20;
const search_funnel = {
  state: {
    sellers_filter: new Filter([], []),
    marketplaces_filter: new Filter([], [], "sales_channel"),
    products: new Filter([], [], "products"),
    targetings: new Filter([], [], "targeting", undefined, undefined, undefined, false),
    targeting_types: new Filter(TARGETING_TYPE_SPLIT.filter(item => item.name !== 'Discovery'), [], "short_name", undefined, undefined, undefined, false),
    currencies: new Filter(Currencies, [], "symbol"),
    period: APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value,
    periodSelectorOptions: [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY, APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY, APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY],
    periodCategory: PERIOD_OPTIONS_V2[APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value].LEFT.queryKey,
    product_table: {
      state: FLOATING_COMPOUND_TABLE_STATES.INTERMEDIATE,
      group_by: 0,
      group_by_text: "",
      group_by_elements: [],
      performance: {
        period: null,
        data: {
          asin: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedAsin"
          },
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedSeller"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedMarketplace"
          },
          keyword: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedKeyword"
          },
          keyword_type: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedKeywordType"
          }
        }
      },
      opportunities: {
        period: null,
        data: {
          asin: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedAsin"
          },
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedSeller"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedMarketplace"
          },
          keyword: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedKeyword"
          },
          keyword_type: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {
              purchase_count: "desc",
              click_count: "desc",
              impression_count: "desc"
            },
            fetch: "searchFunnelFetchReportGroupedKeywordType"
          }
        }
      }
    },
    currentTab: 0,
    currentTabValue: "performance",
    tabs: [{
      text: "Performance",
      value: "performance",
      activeBg: "#FFF",
      activeColor: "#E05E0F",
      feature: 'searchFunnelPerformance'
    }, {
      text: "Opportunities",
      value: "opportunities",
      activeBg: "#FFF",
      activeColor: "#E05E0F",
      feature: 'searchFunnelOpportunities'
    }],
    periodOptions: [PERIOD_OPTIONS.PREV_PERIOD, PERIOD_OPTIONS.SAME_PERIOD_LY],
    currentPeriod: {
      [APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value]: {
        title: {
          prev_period: "Last week vs previous week",
          same_period_ly: "Last week vs same period last year"
        },
        format: "MMM D, YYYY",
        date: moment().startOf("isoWeek").subtract(1, 'week'),
        groupBy: DATE_PICKER_RANGE_TITLES.LAST_WEEK,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: {
        title: {
          prev_period: "Current month vs previous month",
          same_period_ly: "Current month vs same period last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("month"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_MONTH,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: {
        title: {
          prev_period: "Current quarter vs previous quarter",
          same_period_ly: "Current quarter vs same period last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("quarter"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_QUARTER,
        groupByCompare: {
          title: 'Preceding Period',
          subtitle: '(match to date)'
        }
      }
    },
    periodTable: {
      performance: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      opportunities: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      period_page: 1
    },
    renderedFilterNames: new Set()
  },
  mutations: {
    searchFunnelSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    searchFunnelMarketplacesFilterSet(state, payload) {
      state.marketplaces_filter.restore(payload);
    },
    searchFunnelProductsFilterSet(state, payload) {
      state.products = payload;
    },
    searchFunnelSetPeriod(state, payload) {
      state.period = payload;
    },
    searchFunnelSetPeriodCategory(state, payload) {
      state.periodCategory = payload;
    },
    searchFunnelSetCurrentTab(state, payload) {
      const {
        tabIndex,
        tabValue
      } = payload;
      state.currentTab = tabIndex;
      state.currentTabValue = tabValue;
    },
    searchFunnelSetPeriodTableItems(state, payload) {
      state.periodTable['performance'].items = payload;
      state.periodTable['opportunities'].items = payload;
    },
    searchFunnelDeselectPeriodTable(state) {
      state.tabs.forEach(({
        value
      }) => {
        (state.periodTable[value]?.items ?? []).forEach(item => {
          item.selected = undefined;
        });
      });
    },
    searchFunnelSetPeriodTableMinMax(state, payload) {
      state.periodTable['performance'].minMax = payload;
      state.periodTable['opportunities'].minMax = payload;
    },
    searchFunnelSetPeriodTableMaxCharCount(state, payload) {
      state.periodTable['performance'].maxCharCount = payload;
      state.periodTable['opportunities'].maxCharCount = payload;
    },
    searchFunnelSetProductTableMinMax(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].minMax = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].minMax = payload;
    },
    searchFunnelSetProductTableTotal(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].total = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].total = payload;
    },
    searchFunnelSetProductTableTotalPages(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].totalPages = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].totalPages = payload;
    },
    searchFunnelSetProductTablePage(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].page = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].page = payload;
    },
    searchFunnelSetProductTablePerPage(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].perPage = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].perPage = payload;
    },
    searchFunnelSetProductTableGroupBy(state, payload) {
      state.product_table.group_by = payload;
      state.product_table.group_by_text = state.product_table.group_by_elements[payload].key;
    },
    searchFunnelSetProductTablePeriod(state, payload) {
      state.product_table['performance'].period = payload;
      state.product_table['opportunities'].period = payload;
    },
    searchFunnelSetProductTableItems(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].items = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].items = payload;
    },
    searchFunnelSetProductTableMaxCharCount(state, payload) {
      state.product_table['performance'].data[state.product_table.group_by_text].maxCharCount = payload;
      state.product_table['opportunities'].data[state.product_table.group_by_text].maxCharCount = payload;
    },
    searchFunnelSetProductTableState(state, payload) {
      state.product_table.state = payload;
    },
    searchFunnelSetProductTableGroupByElements(state, payload) {
      state.product_table.group_by_elements = payload;
    },
    searchFunnelSetProductTableSort(state, {
      sort,
      direction
    }) {
      state.product_table['performance'].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
      state.product_table['opportunities'].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
    },
    searchFunnelIncrementPeriodPage(state) {
      state.periodTable.period_page += 1;
    },
    searchFunnelDefaultCurrencySet(state, payload) {
      // We need to update the currency filter
      state.currencies.selectOnly({
        symbol: payload
      }, 'symbol');
      state.currencies.apply();
    }
  },
  getters: {
    searchFunnelGetFilters(state) {
      return () => {
        const searchQueryTypeMap = {
          "Non-branded": "Non-Branded",
          "Branded": "Branded",
          "Competitors": "Competitor",
          "Discovery": "Discovery"
        };
        return {
          seller_id: state.sellers_filter.filterValues,
          marketplaces: state.marketplaces_filter.filterValues,
          asin_list: state.products.selected.map(product => product.asin).filter(Boolean),
          search_query_type_list: state.targeting_types.selectedValues.map(item => searchQueryTypeMap[item]),
          search_query_list: state.targetings.selected.flatMap(({
            keyword_id_list
          }) => keyword_id_list)
        };
      };
    },
    searchFunnelGetPeriod(state) {
      return () => state.period;
    },
    searchFunnelGetPeriodCategory(state) {
      return () => state.periodCategory;
    },
    searchFunnelGetTab(state) {
      return () => state.currentTab;
    },
    searchFunnelGetTabValue(state) {
      return () => state.currentTab;
    },
    searchFunnelGetProductTablePage(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page;
    },
    searchFunnelGetProductTablePerPage(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage;
    },
    searchFunnelGetProductTableTotalPages(state) {
      return () => state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.totalPages;
    },
    searchFunnelGetAccountState(state) {
      return () => {
        const res = {
          sellers: state.sellers_filter.defaultList,
          marketplaces: state.marketplaces_filter.defaultList
        };
        return res;
      };
    },
    searchFunnelGetProductTableSort(state) {
      return () => {
        let obj = {
          sort_by: [],
          sort_direction: []
        };
        for (const [key, value] of Object.entries(state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.sort)) {
          obj['sort_by'].push(key);
          obj['sort_direction'].push(value);
        }
        return obj;
      };
    },
    searchFunnelGetProductTablePager(state) {
      return () => ({
        page: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page,
        page_size: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage
      });
    },
    searchFunnelGetProductTableGroupBy(state) {
      return () => state.product_table.group_by;
    },
    searchFunnelSingleMarketplace(state) {
      return () => {
        const filteredMarketplaces = state.marketplaces_filter.filterValues;
        return filteredMarketplaces.length === 1;
      };
    },
    searchFunnelGetPeriodOptions(state) {
      const currentPeriod = state.period;
      return [PERIOD_OPTIONS_V2[currentPeriod].LEFT, PERIOD_OPTIONS_V2[currentPeriod].RIGHT];
    }
  },
  actions: {
    async searchFunnelFetchPeriodTableData({
      commit,
      getters,
      state
    }) {
      try {
        const dateConfig = getters.dateConfigQueryGet();
        const params = {
          period: state.period,
          ...getters.searchFunnelGetFilters(),
          ...getters.currencyConfigQueryGet(),
          ...dateConfig,
          period_page: state.periodTable.period_page
        };
        let response = await request('/market_insights/search_funnel/evolution', 'POST', params);
        let data = response.data;
        if (data) {
          commit("searchFunnelSetPeriodTableItems", data);
          commit('searchFunnelSetPeriodTableMaxCharCount', {
            number: computeNumberMaxCharCount(data),
            percentage: computePercentageMaxCharCount(data),
            currency: computeCurrencyMaxCharCount(data)
          });
          commit("searchFunnelSetPeriodTableMinMax", computeMinMax(data));
        }
      } catch (err) {
        //console.log(err);
      }
    },
    async searchFunnelFetchReportGroupedSeller({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.searchFunnelGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.searchFunnelGetFilters(),
          ...getters.searchFunnelGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        let response = await request("/market_insights/search_funnel/report/seller", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('searchFunnelSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('searchFunnelSetProductTableItems', report);
            commit('searchFunnelSetProductTableTotal', total?.pop() ?? {});
            commit('searchFunnelSetProductTableMaxCharCount', {
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report),
              currency: computeCurrencyMaxCharCount(report)
            });
            commit('searchFunnelSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async searchFunnelFetchReportGroupedMarketplace({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.searchFunnelGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.searchFunnelGetFilters(),
          ...getters.searchFunnelGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        let response = await request("/market_insights/search_funnel/report/marketplace", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('searchFunnelSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('searchFunnelSetProductTableItems', report);
            commit('searchFunnelSetProductTableTotal', total?.pop() ?? {});
            commit('searchFunnelSetProductTableMaxCharCount', {
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report),
              currency: computeCurrencyMaxCharCount(report)
            });
            commit('searchFunnelSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async searchFunnelFetchReportGroupedKeyword({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.searchFunnelGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.searchFunnelGetFilters(),
          ...getters.searchFunnelGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        let response = await request("/market_insights/search_funnel/report/keyword", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('searchFunnelSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('searchFunnelSetProductTableItems', report);
            commit('searchFunnelSetProductTableTotal', total?.pop() ?? {});
            commit('searchFunnelSetProductTableMaxCharCount', {
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report),
              currency: computeCurrencyMaxCharCount(report)
            });
            commit('searchFunnelSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async searchFunnelFetchReportGroupedKeywordType({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.searchFunnelGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.searchFunnelGetFilters(),
          ...getters.searchFunnelGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        let response = await request("/market_insights/search_funnel/report/keyword_type", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('searchFunnelSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('searchFunnelSetProductTableItems', report);
            commit('searchFunnelSetProductTableTotal', total?.pop() ?? {});
            commit('searchFunnelSetProductTableMaxCharCount', {
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report),
              currency: computeCurrencyMaxCharCount(report)
            });
            commit('searchFunnelSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async searchFunnelFetchReportGroupedAsin({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.searchFunnelGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.searchFunnelGetFilters(),
          ...getters.searchFunnelGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        let response = await request("/market_insights/search_funnel/report/asin", 'POST', params, false, true, 'cors');
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit('searchFunnelSetProductTableTotalPages', total?.[0]?.row_count ?? 0);
            commit('searchFunnelSetProductTableItems', report);
            commit('searchFunnelSetProductTableTotal', total?.pop() ?? {});
            commit('searchFunnelSetProductTableMaxCharCount', {
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report),
              currency: computeCurrencyMaxCharCount(report)
            });
            commit('searchFunnelSetProductTableMinMax', computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    searchFunnelSetDefaultCurrency({
      getters,
      commit
    }) {
      //console.log('getters', getters.currencyConfigQueryGet())
      commit('searchFunnelDefaultCurrencySet', getters.currencyConfigQueryGet().currency);
    },
    searchFunnelSetPeriod({
      commit
    }, period) {
      commit('searchFunnelSetPeriod', period);
    },
    searchFunnelSetPeriodCategory({
      commit
    }, periodCategory) {
      commit('searchFunnelSetPeriodCategory', periodCategory);
    },
    searchFunnelSetTab({
      commit
    }, tab) {
      commit('searchFunnelSetCurrentTab', tab);
    },
    searchFunnelIncrementPeriodPage({
      commit
    }) {
      commit('searchFunnelIncrementPeriodPage');
    },
    searchFunnelSetProductTableGroupBy({
      commit
    }, groupBy) {
      commit('searchFunnelSetProductTableGroupBy', groupBy);
    },
    searchFunnelSetProductTablePeriod({
      commit
    }, period) {
      commit('searchFunnelSetProductTablePeriod', period);
    },
    searchFunnelSetProductTableState({
      commit
    }, payload) {
      commit('searchFunnelSetProductTableState', payload);
    },
    searchFunnelSetProductTablePage({
      commit
    }, page) {
      commit('searchFunnelSetProductTablePage', page);
    },
    searchFunnelSetProductTablePerPage({
      commit
    }, perPage) {
      commit('searchFunnelSetProductTablePerPage', perPage);
    },
    searchFunnelSetProductTableTotalPages({
      commit
    }, totalPages) {
      commit('searchFunnelSetProductTableTotalPages', totalPages);
    },
    searchFunnelSetProductTableGroupByElements({
      commit,
      getters
    }) {
      const {
        sellers,
        marketplaces
      } = getters.searchFunnelGetAccountState();
      const {
        SELLER,
        MARKETPLACE,
        PRODUCT_SKU,
        PRODUCT_ASIN,
        PRODUCT_PARENT,
        SEGMENT,
        BRAND,
        CATEGORY,
        COMPETITOR,
        KEYWORD,
        KEYWORD_TYPE
      } = GROUP_BY_TAB_ELEMENTS;
      const DEFAULT_TABS = [PRODUCT_ASIN, KEYWORD_TYPE, KEYWORD];
      const prefixTabs = [];
      if (sellers.length > 1) {
        prefixTabs.push(SELLER);
      }
      if (marketplaces.length > 1) {
        prefixTabs.push(MARKETPLACE);
      }
      const suffixTabs = [...DEFAULT_TABS];
      const finalTabs = [...prefixTabs, ...suffixTabs];
      commit("searchFunnelSetProductTableGroupByElements", finalTabs);
      commit("searchFunnelSetProductTableGroupBy", finalTabs.indexOf(KEYWORD));
    },
    searchFunnelSetProductTableSort({
      commit
    }, payload) {
      commit('searchFunnelSetProductTableSort', payload);
    },
    async getSearchFunnelKeywords({
      state,
      getters
    }, payload) {
      state.marketplaces_filter._key = "marketplace_id";
      const result = await request("/market_insights/search_funnel/filters/keywords", 'POST', {
        ...getters.searchFunnelGetFilters(),
        keyword_list: payload?.keyword
      }, false, true, 'cors');
      state.marketplaces_filter._key = "sales_channel";
      if (result && result.data && result.data.keywords) {
        let keywords = result.data.keywords;
        return keywords.map(({
          search_query
        }) => ({
          targeting: search_query,
          keyword_id_list: [search_query],
          id: search_query
        }));
      }
    }
  }
};
export default search_funnel;